import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';
import {QUICK_SKIP_THRESHOLD_FOR_TURBO_POPUP_SUGGESTION} from '@gongxigames/framework/slotV2/types';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class SpinUIAct extends SyncUIActDecorator {
    public execute(): void {
        listenUIDisabled(this);

        const countOfSkipButtonPressed = slotStore.countOfSkipButtonPressed.value;

        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'SpinningUIState');
        this.emitter.on('Game.command.idle.activated', () => {
            if (countOfSkipButtonPressed === slotStore.countOfSkipButtonPressed.value) {
                slotStore.countOfSkipButtonPressed.value = 0;
            }
            this.onExecuted?.();
        });
        this.emitter.on('UI.quickStopButton.pressed', this.onSkipStartedByButton.bind(this));

        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            slotStore.batchUpdate({
                feature_type: data
            });

            this.removeAllListeners();
            this.onExecuted?.();
        });
    }

    protected onSkipStartedByButton(): void {
        // TODO understand, do we need 'UI.command.skip', everything works with only 'UI.command.spin' properly
        // this.emitter.emit('UI.command.skip');
        this.emitter.emit('UI.command.spin');

        if (slotStore.logic_nextActionIsSpin.value) {
            slotStore.countOfSkipButtonPressed.value++;
        }

        if(slotStore.countOfSkipButtonPressed.value === QUICK_SKIP_THRESHOLD_FOR_TURBO_POPUP_SUGGESTION) {
            slotStore.countOfSkipButtonPressed.value = 0;
            this.emitter.emit('UI.showTurboModeHint');
        }
    }

    getName(): string {
        return 'SpinUIAct';
    }
}